import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { name, id },
} = checkout;

const validations = [
  Yup.object().shape({
    [name.name]: Yup.string().required(name.errorMsg),
    [id.name]: Yup.string().required(id.errorMsg),
  }),
];

export default validations;
